/**
 * Auto-inserts the dots while the user types a German date (TT.MM.JJJJ).
 * Pure helper used by `FormDateField`; validation stays in yup.
 */
export const formatGermanDateInput = (
  value: string,
  previousValue: string,
): string => {
  const lastThreeChars = value.slice(-3);

  // "5." -> "05."
  if (value.length === 2 && value[1] === '.') {
    return `0${value[0]}.`;
  }

  // "01.3." -> "01.03."
  if (lastThreeChars[0] === '.' && lastThreeChars[2] === '.') {
    return `${value.slice(0, -3)}.0${lastThreeChars[1]}.`;
  }

  // "01" -> "01." / "01.03" -> "01.03." (only while typing forward, not on delete)
  if (
    (value.length === 2 || value.length === 5) &&
    value.length > previousValue.length
  ) {
    return `${value}.`;
  }

  // avoid ".."
  if (value.endsWith('..')) {
    return value.slice(0, -1);
  }

  return value;
};
